import { render, staticRenderFns } from "./CellPhoneModel.vue?vue&type=template&id=423269bc&scoped=true"
import script from "./CellPhoneModel.vue?vue&type=script&lang=js"
export * from "./CellPhoneModel.vue?vue&type=script&lang=js"
import style0 from "./CellPhoneModel.vue?vue&type=style&index=0&id=423269bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423269bc",
  null
  
)

export default component.exports